/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { MessagePlugin as MessagePlugin$1 } from './Message.js';
import './style/css.js';
import './type.js';
import MessageComponent from './MessageComponent.js';
import '../_chunks/dep-605e961c.js';
import '../_chunks/dep-f66447d3.js';
import '../_chunks/dep-8c8a3203.js';
import '../_chunks/dep-6ccd10f6.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-2055661d.js';
import 'react';
import 'classnames';
import '../_util/react-render.js';
import 'react-dom';
import '../_util/noop.js';
import './const.js';
import './config.js';
import './defaultProps.js';
import './useMessageClass.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import './MessageClose.js';
import 'tdesign-icons-react';
import '../hooks/useGlobalIcon.js';
import './MessageIcon.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import '../common/Portal.js';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-f41383e1.js';
import '../_chunks/dep-97bb7f6b.js';
import '../_chunks/dep-01305891.js';
import '../_chunks/dep-bd50d435.js';
import '../_chunks/dep-18226b92.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/usePersistFn.js';

var Message = MessageComponent;
var message = MessagePlugin$1;
var MessagePlugin = MessagePlugin$1;

export { Message, MessagePlugin, Message as default, message };
//# sourceMappingURL=index.js.map
